<div id="student-enroll-overlay" [class]="visibility()">
  <div id="student-enroll-container">
    <h1>{{ model | name }}</h1>

    <form id="student-enroll-form">
      <div style="display: grid; grid-template-columns: auto auto auto auto">
        @for (enrollment of student?.enrollments; track enrollment; let i = $index) {
          <div class="enrollment-name">{{ enrollment.name }}</div>
          <div>
            @if (enrollment.begin) {
              <input
                id="student-enroll-begin-input{{ i }}"
                name="student-enroll-begin-input{{ i }}"
                type="date"
                [(ngModel)]="enrollment.begin" />
            }
            @if (!enrollment.begin) {
              <button
                class="button-add"
                (click)="enroll(enrollment)">
                +
              </button>
            }
          </div>
          <div>
            @if (enrollment.end) {
              <input
                id="student-enroll-end-input{{ i }}"
                name="student-enroll-end-input{{ i }}"
                type="date"
                [(ngModel)]="enrollment.end" />
            }
          </div>
          <div>
            @if (enrollment.begin) {
              <button
                class="button-remove"
                (click)="deroll(enrollment)">
                X
              </button>
            }
          </div>
        }
      </div>
    </form>

    <div style="text-align: center">
      <button class="button-save" (click)="save()">Save</button>
      <button class="button-close" (click)="close()">Close</button>
    </div>
  </div>
</div>
